<template>
  <AulaButtons v-if="showRepeatingEventOptions" class="dropdown-toggles">
    <CalendarEventFooterDropdown class="text-center" :selected="responseType === eventResponseStatus.ACCEPTED">
      <template #button-content>
        <IconContainer>
          <Icon :name="iconClassEnum.CHECKMARK_2" />
        </IconContainer>
        {{ $getText('CALENDAR_ACCEPT_EVENT_BUTTON') }}
      </template>
      <b-dropdown-item-btn
        v-if="showRepeatingOccurrenceOption"
        @click="handleResponseCurrentEventChange(eventResponseStatus.ACCEPTED)"
      >
        {{ $getText('CALENDAR_EDIT_REPEATING_OCCURRENCE') }}
      </b-dropdown-item-btn>
      <b-dropdown-item-btn v-if="showRepeatingSeriesOption" @click="handleResponseChange(eventResponseStatus.ACCEPTED)">
        {{ $getText('CALENDAR_EDIT_REPEATING_SERIES') }}
      </b-dropdown-item-btn>
    </CalendarEventFooterDropdown>
    <CalendarEventFooterDropdown v-if="showTentativeResponse" class="text-center">
      <template #button-content>
        <IconContainer>
          <Icon :name="iconClassEnum.QUESTIONMARK" />
        </IconContainer>
        {{ $getText('CALENDAR_MAYBE_EVENT_BUTTON') }}
      </template>
      <b-dropdown-item-btn
        v-if="showRepeatingOccurrenceOption"
        @click="handleResponseCurrentEventChange(eventResponseStatus.TENTATIVE)"
      >
        {{ $getText('CALENDAR_EDIT_REPEATING_OCCURRENCE') }}
      </b-dropdown-item-btn>
      <b-dropdown-item-btn
        v-if="showRepeatingSeriesOption"
        @click="handleResponseChange(eventResponseStatus.TENTATIVE)"
      >
        {{ $getText('CALENDAR_EDIT_REPEATING_SERIES') }}
      </b-dropdown-item-btn>
    </CalendarEventFooterDropdown>
    <CalendarEventFooterDropdown class="text-center">
      <template #button-content>
        <IconContainer>
          <Icon :name="iconClassEnum.CLOSE" />
        </IconContainer>
        {{ $getText('CALENDAR_REJECT_EVENT_BUTTON') }}
      </template>
      <b-dropdown-item-btn
        v-if="showRepeatingOccurrenceOption"
        @click="handleResponseCurrentEventChange(eventResponseStatus.DECLINED)"
      >
        {{ $getText('CALENDAR_EDIT_REPEATING_OCCURRENCE') }}
      </b-dropdown-item-btn>
      <b-dropdown-item-btn v-if="showRepeatingSeriesOption" @click="handleResponseChange(eventResponseStatus.DECLINED)">
        {{ $getText('CALENDAR_EDIT_REPEATING_SERIES') }}
      </b-dropdown-item-btn>
    </CalendarEventFooterDropdown>
  </AulaButtons>
  <ButtonToggles
    v-else
    class="response-toggles"
    :selected="responseType"
    :options="responseOptions"
    :with-checkmark="false"
    @change="handleResponseChange"
  />
</template>
<script>
import { eventResponseStatus } from '../../enums/eventResponseStatus';
import CalendarEventFooterDropdown from './CalendarEventFooterDropdown';
import AulaButtons from '../../components/AulaButtons';
import ButtonToggles from '../../components/ButtonToggles/ButtonToggles.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import Icon from '../../components/Icon.vue';
import IconContainer from '../../components/IconContainer.vue';

export default {
  components: { IconContainer, Icon, ButtonToggles, AulaButtons, CalendarEventFooterDropdown },
  props: {
    responseType: { type: String, default: null },
    showTentativeResponse: { type: Boolean, default: false },
    showRepeatingOccurrenceOption: { type: Boolean, default: true },
    showRepeatingSeriesOption: { type: Boolean, default: true },
    showUpdateAnswer: { type: Boolean, default: false },
    disabledAccept: { type: Boolean, default: false },
    showRepeatingEventOptions: { type: Boolean, default: false },
  },
  emits: ['respondCurrentEvent', 'respond'],
  data() {
    return {
      eventResponseStatus,
    };
  },
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    responseOptions() {
      let buttonAcceptText = this.$t('calendar.accepted');
      if (this.showUpdateAnswer) {
        buttonAcceptText = this.$t('calendar.update_answer');
      }
      const optionAccept = {
        label: buttonAcceptText,
        value: eventResponseStatus.ACCEPTED,
        icon: iconClassEnum.CHECKMARK_2,
      };
      const optionTentative = {
        label: this.$t('calendar.tentative'),
        value: eventResponseStatus.TENTATIVE,
        icon: iconClassEnum.QUESTIONMARK,
      };
      const optionDecline = {
        label: this.$t('calendar.declined'),
        value: eventResponseStatus.DECLINED,
        icon: iconClassEnum.CLOSE,
      };
      if (this.showTentativeResponse) {
        return [optionAccept, optionTentative, optionDecline];
      }
      return [optionAccept, optionDecline];
    },
  },
  methods: {
    handleResponseChange(responseType) {
      this.$emit('respond', responseType);
    },
    handleResponseCurrentEventChange(responseType) {
      this.$emit('respondCurrentEvent', responseType);
    },
  },
};
</script>
<style lang="scss" scoped>
@use '../../../shared/assets/scss/core/variables' as *;
@use '../../../shared/assets/scss/core/breakpoints' as *;

.response-toggles {
  --gap: 24px;

  width: 100%;
  ::v-deep button.btn.btn-primary {
    text-transform: uppercase;
    font-weight: 700;
  }
}
.dropdown-toggles {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  grid-template-rows: 1fr;
  place-items: center;
  gap: 24px;

  ::v-deep .b-dropdown {
    &.dropdown-select {
      .dropdown-item {
        padding: 10px 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        justify-content: center;
      }
    }

    .dropdown-toggle {
      font-weight: bold;
    }

    &.show .dropdown-toggle {
      color: var(--color-primary-dark);
      .icon-container {
        color: var(--color-primary-dark);
        border-color: var(--color-primary-dark);
      }
    }
    .icon-container {
      --width: 20px;

      border: 1px solid var(--color-primary-darker);
      margin-right: 8px;
      background-color: transparent;
      .aula-icon {
        font-size: 10px;
      }
    }
  }
}

@include breakpoint-lg-down() {
  .response-toggles {
    --gap: 8px;
  }
}
</style>
